import React, { memo, useContext, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { DomainContext } from '../../domain-repository/DomainRepository'

import { getPolicyAndTerms } from '../../services/GetLegalInformation'

import { setPageId } from '../../services/Metrics'

import { FooterWithClose } from '../Footer'
import Loading from '../Loading'

function LegalInformationPage({ handleLogoClick, policy, terms, handleCloseClick, pageId, handleAcceptClick, handleRejectClick, readOnly }) {
  const { t } = useTranslation()

  const {
    language,
  } = useContext(DomainContext)

  const [loading, setLoading] = useState(true)
  const [content, setContent] = useState(null)

  useEffect(() => {
    setPageId({ pageId })
  }, [])

  useEffect(() => {
    const func = () => {
      setLoading(true)
      getPolicyAndTerms(language || 'en')
        .then(result => {
          setContent(result.data)
        })
        .catch(e => {
          handleAcceptClick()
        })
        .finally(() => {
          setLoading(false)
        })
    }

    func()
  }, [])

  return (
    <div>
      <main>
        <div className='legal-page-container' style={{ paddingBottom: '30px' }}>
          <div>
            <div>
              <div onClick={handleLogoClick}>
                <img className='img-fluid pt-3 pb-3' src={require(`../../assets/images/logo.png`)} alt="Guerin" />
              </div>
            </div>
          </div>
          <div className='main-inicial' style={{height: '100%'}}>
            <div className=''>
              <div className=''>
                <div className='w-100'>
                  <Loading active={loading} />
                  <h4 style={{ textAlign: 'center' }}>{t('mobileTermsConditionsTitle')}</h4>
                  <div dangerouslySetInnerHTML={{ __html: content }} />
                </div>
              </div>
            </div>
            {!loading && !readOnly ?
              <div className='legal-info-popup__actions'>
                <button onClick={handleRejectClick} className='btn btn-grey'>{t('reject')}</button>
                <button onClick={handleAcceptClick} className='btn btn-green'>{t('accept')}</button>
              </div>
              : null}
          </div>
        </div>
        <FooterWithClose
          handleCloseClick={handleCloseClick}
          isHidden={!readOnly}
        />
      </main>
    </div>
  )
}

export default LegalInformationPage
